import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "PersonaProgramaPage",
    data() {
        let ss = new MainService();
        return {
            msg: "PersonaProgramaPage",
            ss: ss,
            ajax: {
                "url": ss.indexPersonaPrograma(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Persona', name: 'p.Persona', title: 'Persona' },
                { data: 'Programa', name: 'pp.Programa', title: 'Programa' },
                { data: 'Periodo', name: 'pp.Periodo', title: 'Periodo' },
                { data: 'Gestion', name: 'pp.Gestion', title: 'Gestión' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],

            ajax2: {
                "url": ss.indexPersonaProgramaSub(),
                headers: ss.getToken(),
            },
            columns2: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'NombreSubPrograma', name: 'pps.NombreSubPrograma', title: 'SubPrograma' },
                { data: 'Periodo', name: 'pps.Periodo', title: 'Periodo' },
                { data: 'Gestion', name: 'pps.Gestion', title: 'Gestión' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],

            ajax3: {
                "url": ss.indexPersonaProgramaSubSub(),
                headers: ss.getToken(),
            },
            columns3: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'NombreSubSubPrograma', name: 'ppss.NombreSubSubPrograma', title: 'Diplomado' },
                { data: 'Periodo', name: 'pps.Periodo', title: 'Periodo' },
                { data: 'Gestion', name: 'pps.Gestion', title: 'Gestión' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],

            
            personaprogramas: [],
            personaprograma: {},
            personaprogramasub: {},
            personaprogramasubsub: {},
            personas: [],
            persona:{},
            queryPersona: "",
            defensas:[],
            tipomiembros:[],
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
       
        newPersonaPrograma() {
            this.personaprograma = {};
            this.$refs['frm-personaprograma'].show();
        },
        newPersonaProgramaSub() {
            this.personaprogramasub = {};
            this.$refs['frm-personaprogramasub'].show();
        },
        newPersonaProgramaSubSub() {
            this.personaprogramasubsub = {};
            this.$refs['frm-personaprogramasubsub'].show();
        },
        cancelPersonaProgramaSub() {
           /*  if (this.personaprogramasub.id) {
                this.$refs['view-personaprogramasub'].show();
            } */
            this.$refs['frm-personaprogramasub'].hide();
        },
        cancelPersonaProgramaSubSub() {
            /*  if (this.personaprogramasub.id) {
                 this.$refs['view-personaprogramasub'].show();
             } */
             this.$refs['frm-personaprogramasubsub'].hide();
         },
        showPersonaProgramaSub(id) {
            this.isLoading=true;
            this.ss.showPersonaProgramaSub(id).then(
                (result) => {
                    let response = result.data;
                    this.personaprogramasub = response.data;
                    this.$refs['frm-personaprogramasub2'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },

        showPersonaProgramaSubSub(id) {
            this.isLoading=true;
            this.ss.showPersonaProgramaSubSub(id).then(
                (result) => {
                    let response = result.data;
                    this.personaprogramasubsub = response.data;
                    this.$refs['frm-personaprogramasubsub'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        savePersonaProgramaSub() {
            this.personaprogramasub.PersonaPrograma = this.personaprograma.id;
            this.ss.storePersonaProgramaSub(this.personaprogramasub).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-personaprogramasub2'].hide();
                    this.$refs['frm-personaprogramasub'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },

        savePersonaProgramaSubSub() {
            this.personaprogramasubsub.PersonaProgramaSub = this.personaprogramasub.id;
            this.ss.storePersonaProgramaSubSub(this.personaprogramasubsub).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-personaprogramasubsub'].hide();
                    this.$refs['datatable-personaprogramasubsub'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        showPersonaPrograma(id) {
            this.isLoading=true;
            this.ss.showPersonaPrograma(id).then(
                (result) => {
                    let response = result.data;
                    this.personaprograma = response.data;
                    this.$refs['view-personaprograma'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editPersonaPrograma() {
            this.$refs['frm-personaprograma'].show();
            this.$refs['view-personaprograma'].hide();
        },
        cancelPersonaPrograma() {
            if (this.personaprograma.id) {
                this.$refs['view-personaprograma'].show();
            }
            this.$refs['frm-personaprograma'].hide();
        },
        savePersonaPrograma() {
            this.ss.storePersonaPrograma(this.personaprograma).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-personaprograma'].hide();
                    this.$refs['datatable-personaprograma'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },

        deletePersonaProgramaSub() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyPersonaProgramaSub(this.personaprogramasub)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['frm-personaprogramasub'].hide();
                                this.$refs['datatable-personaprogramasub'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },

        deletePersonaProgramaSubSub() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyPersonaProgramaSubSub(this.personaprogramasubsub)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['frm-personaprogramasubsub'].hide();
                                this.$refs['datatable-personaprogramasubsub'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        
        deletePersonaPrograma() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyPersonaPrograma(this.personaprograma)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-personaprograma'].hide();
                                this.$refs['datatable-personaprograma'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-PersonaPrograma').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showPersonaPrograma(data);
            });

            window.$('.btn-datatable-PersonaProgramaSub').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showPersonaProgramaSub(data);
            });

            window.$('.btn-datatable-PersonaProgramaSubSub').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showPersonaProgramaSubSub(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    watch: {
        queryPersona(q) {
            this.ss.select2Persona(q).then((res) => {
                console.log(res);
                if (res.data.success) {
                    this.personas = res.data.items;
                } else {
                    this.personas = [];
                }
            })
        }
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }else{
           /*  this.getDefensas();
            this.getTipoMiembros(); */
        }
    }
};
